<div class="product-content">
  <div class="left-column">
    <section *ngIf="product.description || product.keySellingPoints">
      <mat-card>
        <mat-card-content>
          <store-selling-info
            [description]="product.description"
            [keySellingPoints]="product.keySellingPoints"
          ></store-selling-info>
        </mat-card-content>
      </mat-card>
    </section>
    <section *ngIf="product.faqs?.length > 0">
      <mat-card>
        <mat-card-content>
          <h2 class="va-component-title">
            {{ 'FRONTEND.STORE.FAQS' | translate }}
          </h2>
          <store-faqs [faqs]="product.faqs"></store-faqs>
        </mat-card-content>
      </mat-card>
    </section>
  </div>
  <div class="right-column">
    <section>
      <mat-card class="price-display-box">
        <mat-card-content>
          <div class="va-component-title">
            {{
              (marketingType === marketingTypeEnum.EndUser ? 'FRONTEND.STORE.PRICE' : 'FRONTEND.STORE.WHOLESALE_COST')
                | translate
            }}
          </div>
          <billing-ui-price-display
            [appPrice]="appPrice"
            [align]="'start'"
            [currencyCode]="currency"
            [size]="'large'"
            [form]="'verbose'"
          ></billing-ui-price-display>

          <div *ngIf="!isAddon && product.usesEditions" class="all-pricing-link">
            <a (click)="editionTabSelected.emit(true)">View all pricing</a>
          </div>
        </mat-card-content>
      </mat-card>
    </section>
    <section>
      <store-product-requirements
        [marketingType]="marketingType"
        [personaType]="personaType"
        [partnerId]="partnerId"
        [marketId]="marketId"
        [product]="product"
      ></store-product-requirements>
    </section>
    <section *ngIf="orderForm?.orderForm || fulfillmentOrderConfig?.usesFulfillmentForm">
      <mat-card>
        <mat-card-content>
          <div class="requirements-header">
            <div class="va-component-title">
              {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PREVIEW_FORMS.LABEL' | translate }}
            </div>
            <mat-icon
              [glxyPopover]="requiredFormsPopover"
              (mouseenter)="showRequiredFormsPopover = true"
              (mouseleave)="showRequiredFormsPopover = false"
              inline
            >
              info_outline
            </mat-icon>
            <glxy-popover #requiredFormsPopover [isOpen]="showRequiredFormsPopover">
              <glxy-popover-title>
                {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PREVIEW_FORMS.TOOLTIP.TITLE' | translate }}
              </glxy-popover-title>
              {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PREVIEW_FORMS.TOOLTIP.DESCRIPTION' | translate }}
            </glxy-popover>
          </div>
          <ul>
            <li *ngIf="orderForm?.orderForm">
              <a (click)="openOrderFormPreview()">
                {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PREVIEW_FORMS.ORDER_FORM' | translate }}
              </a>
            </li>
            <li *ngIf="fulfillmentOrderConfig?.usesFulfillmentForm">
              <a (click)="openFulfillmentFormPreview()">
                {{ 'FRONTEND.STORE.PRODUCT_DETAILS.PREVIEW_FORMS.FULFILLMENT_FORM' | translate }}
              </a>
            </li>
          </ul>
        </mat-card-content>
      </mat-card>
    </section>
    <section *ngIf="product.needHelp">
      <mat-card>
        <mat-card-content>
          <h2 class="va-component-title">{{ 'FRONTEND.STORE.CONTACT_US' | translate }}</h2>
          <store-need-help [needHelp]="product.needHelp"></store-need-help>
        </mat-card-content>
      </mat-card>
    </section>
    <section *ngIf="product.videos && product.videos.length > 0">
      <mat-card>
        <mat-card-content>
          <h2 class="va-component-title"></h2>
          <store-videos [videos]="product.videos"></store-videos>
        </mat-card-content>
      </mat-card>
    </section>
    <section *ngIf="product.addons?.length">
      <mat-card>
        <mat-card-content>
          <h2 class="va-component-title">
            {{ 'FRONTEND.STORE.PRODUCTS_AND_ADDONS' | translate }}
          </h2>
          <store-addon-list
            [addons]="getAddons()"
            [addonPrices]="addonPrices"
            [currency]="currency"
            (addonSelected)="onAddonSelected($event)"
          ></store-addon-list>
        </mat-card-content>
      </mat-card>
    </section>
  </div>
</div>
